import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { useParams } from "react-router-dom";
import { get } from "../../helpers/api_helper";
import { showErrorToast } from "../../helpers/toastMessages";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import Logo from "../../assets/images/Elebert-Logo.png";
import * as api from "../../constants/api_constants";
import CertificateTypeSelector from "./CertificateTypeSelector";
import CertificateForm from "./CertificateForm";
import CertificatePreview from "./CertificatePreview";

const AddCertificate = () => {
  const { certificateId } = useParams();
  const [selectedCertificateType, setSelectedCertificateType] = useState("");
  const [certificateData, setCertificateData] = useState({
    certificateType: "",
    recipientName: "",
    companyName: "",
    certificateName: "",
    certificateNumber: "",
    registrationNumber: "",
    courseType: "",
    startDate: "",
    issueDate: "",
    endDate: "",
    duration: "",
    email: "",
    mobileNumber: "",
    dept: "",
    documents: null,
    hackathonName: "",
    teamName: "",
    courseName: "",
    trainingProgramName: "",
  });
  console.log("cert",certificateData);
  
  const [showCertificate, setShowCertificate] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);

  useEffect(() => {
    if (certificateId) fetchCertificateData();
  }, [certificateId]);

  const fetchCertificateData = async () => {
    try {
      const { data: certData } = await get(api.GET_CERTIFICATE_BY_ID(certificateId));
      if (!certData) {
        showErrorToast("No certificate data found");
        return;
      }

      const updatedData = {
        certificateType: certData.certificateType?.toLowerCase() || "",
        recipientName: certData.internName || certData.emp_name || "",
        companyName: certData.companyName || "",
        certificateName: certData.certificateName || "",
        certificateNumber: certData.certificateNumber || "",
        registrationNumber: certData.registrationNumber || "",
        courseType: certData.courseType?.toLowerCase() || "",
        startDate: certData.startDate?.slice(0, 10) || "",
        issueDate: certData.issuedDate?.slice(0, 10) || certData.endDate?.slice(0, 10) || "",
        endDate: certData.endDate?.slice(0, 10) || "",
        duration: certData.duration?.toString() || "",
        email: certData.email || "",
        mobileNumber: certData.mobileNumber || "",
        dept: certData.department || "",
        documents: null,
        hackathonName: certData.hackathonName || "",
        teamName: certData.teamName || "",
        courseName: certData.courseName || "",
        trainingProgramName: certData.trainingProgramName || "",
      };

      console.log("Fetched certificate data:", updatedData);
      setCertificateData(updatedData);
      setSelectedCertificateType(certData.certificateType?.toLowerCase() || "");
    } catch (err) {
      console.error("Error fetching certificate data:", err);
      showErrorToast("Failed to fetch certificate data");
    }
  };

  const handleTypeSubmit = (certificateType) => {
    console.log("Selected certificate type:", certificateType);
    setSelectedCertificateType(certificateType);
    if (!certificateId) {
      // Only reset data in add mode
      resetCertificateData(certificateType);
    }
  };

  const resetCertificateData = (certificateType) => {
    const blankData = {
      certificateType: certificateType,
      recipientName: "",
      companyName: "",
      certificateName: "",
      certificateNumber: "",
      registrationNumber: "",
      courseType: "",
      startDate: "",
      issueDate: "",
      endDate: "",
      duration: "",
      email: "",
      mobileNumber: "",
      department: "",
      documents: null,
      hackathonName: "",
      teamName: "",
      courseName: "",
      trainingProgramName: "",
    };
    console.log("Resetting certificate data:", blankData);
    setCertificateData(blankData);
  };

  const handleFormSubmit = (data) => {
    console.log("Form submitted with data:", data);
    setSubmittedData(data);
    setShowCertificate(true);
    // Save to localStorage
    const savedCertificates = JSON.parse(localStorage.getItem("certificates") || "[]");
    savedCertificates.push(data);
    localStorage.setItem("certificates", JSON.stringify(savedCertificates));
    console.log("Saved to localStorage:", savedCertificates);
  };

  return (
    <div className="page-content">
      {showCertificate ? (
        <CertificatePreview
          submittedData={submittedData}
          certificateId={certificateId}
        />
      ) : (
        <Container fluid style={{ padding: "0px", gap: "10px" }}>
          <PageSubHeader
            heading={certificateId ? "Edit Certificate" : "Add Certificate"}
            routePath="Home"
            pageName="Certificates"
          />
          <Row className="p-4">
            <Col>
              <div className="text-center mb-4">
                <img src={Logo} alt="Company Logo" height="100" />
              </div>
              <CertificateTypeSelector
                initialType={certificateData.certificateType}
                onSubmit={handleTypeSubmit}
                certificateId={certificateId}
              />
            </Col>
          </Row>
          {selectedCertificateType && (
            <CertificateForm
              key={selectedCertificateType}
              certificateId={certificateId}
              certificateData={certificateData}
              selectedCertificateType={selectedCertificateType}
              onSubmit={handleFormSubmit}
            />
          )}
          <Footer
            save={() => {
              if (selectedCertificateType) {
                console.log("Triggering certificate form submission");
                document
                  .querySelector("#certificateForm")
                  ?.dispatchEvent(new Event("submit", { cancelable: true }));
              } else {
                console.log("No certificate type selected, cannot submit");
              }
            }}
          />
        </Container>
      )}
    </div>
  );
};

export default AddCertificate;